import axios from 'axios';

/**
 * Fetch all notes for a business, optionally filtered by invoice
 * @param {string} businessId
 * @param {Object} options
 * @returns {Promise<Array>}
 */
export const fetchNotes = async (businessId, options = {}) => {
  try {
    const response = await axios.get(`/businesses/${businessId}/notes`, { params: options });
    return response.data.data.notes;
  } catch (error) {
    console.error('Error fetching notes:', error);
    throw error;
  }
};

/**
 * Create a new note
 * @param {string} businessId
 * @param {Object} data
 * @returns {Promise<Object>}
 */
export const createNote = async (businessId, data) => {
  try {
    const response = await axios.post(`/businesses/${businessId}/notes`, data);
    return response.data.data.note;
  } catch (error) {
    console.error('Error creating note:', error);
    throw error;
  }
};

/**
 * Update an existing note
 * @param {string} businessId
 * @param {string} noteId
 * @param {Object} data
 * @returns {Promise<Object>}
 */
export const updateNote = async (businessId, noteId, data) => {
  try {
    const response = await axios.put(`/businesses/${businessId}/notes/${noteId}`, data);
    return response.data.data.note;
  } catch (error) {
    console.error('Error updating note:', error);
    throw error;
  }
};

/**
 * Delete a note (soft delete)
 * @param {string} businessId
 * @param {string} noteId
 * @returns {Promise<void>}
 */
export const deleteNote = async (businessId, noteId) => {
  try {
    await axios.delete(`/businesses/${businessId}/notes/${noteId}`);
  } catch (error) {
    console.error('Error deleting note:', error);
    throw error;
  }
};
